import axios from "axios";

import { ENV } from "@/utils/env";

export const postRefresh = () =>
  axios.post(
    `${ENV.serviceUrl || "http://localhost:8000"}/api/v1/admin/auth/refresh`,
    {},
    { withCredentials: true }
  );
